import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
lessRequire('modules/shared/form-elements/checkbox.less');

const Checkbox = props => {
	let checked = !!props.input.value || props.shouldCheck || false;

	return (
		<div className={props.className || 'form-element-checkbox'}>
			<div className={ props.isSlide ? 'checkbox-slide' : 'checkbox' }>
				<input
					type="checkbox"
					id={props.input.name}
					disabled={props.shouldDisable}
					checked={props.shouldDisable && props.shouldUncheck ? false : checked}
					onChange={e => {
						props.input.onChange(props.input.value, e);
					} }
					{...props.input}
				/>
				<label htmlFor={props.input.name} />
			</div>
			<label htmlFor={props.input.name} className="label-name font-proxima-nova-regular">
				{props.labelText}
				{props.remark && <i className="font-times-new-roman-ps">{props.remark}</i>}
			</label>
		</div>
	);
};

Checkbox.propTypes = {
	input: PropTypes.object,
	labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	remark: PropTypes.string,
	className: PropTypes.string,
	onChange: PropTypes.func,
	shouldCheck: PropTypes.bool,
	shouldUncheck: PropTypes.bool,
	shouldDisable: PropTypes.bool,
	isSlide: PropTypes.bool
};

export default Checkbox;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/checkbox.js